





































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateConversationTopicRequest from '@/models/ConversationTopics/CreateConversationTopicRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyGroupStatus from '@/models/AgencyGroups/AgencyGroupStatus';
import ListUtils from '@/lib/listUtils';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';
import ConversationTopicType from '@/models/ConversationTopics/ConversationTopicType';

@Component({
    name: 'ConversationTopicCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new ConversationTopicDto();
  conversationTopicType = ConversationTopicType;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new ConversationTopicDto();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get conversationTopicTypes() {
    return ListUtils.conversationTopicTypes();
  }

  get desks() {
    if (this.entity.branch) {
      return this.entity.branch.desks;
    }
    return [];
  }

  get branches() {
      return AgencySettingsModule.branches;
  }

  get businessHours() {
      return AgencySettingsModule.businessHours;
  }


  get groups() {
    return AgencySettingsModule.agencyGroups.filter(function(agencyGroup){
      if (agencyGroup.status === AgencyGroupStatus.Active ) {
        return true;
      }
      return false;
    })
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateConversationTopicRequest();
    request.type = this.entity.type;
    request.businessHoursId = this.entity.businessHours.id;
    request.isBusinessHoursNotificationEnabled = this.entity.isBusinessHoursNotificationEnabled;
    request.businessHoursGroupId = this.entity.businessHoursGroup.id;
    request.outOfHoursGroupId = this.entity.outOfHoursGroup.id;  
    request.isOutOfHoursNotificationEnabled = this.entity.isOutOfHoursNotificationEnabled;
    request.branchId = null;
    request.deskId = null;
   if (this.entity.type === ConversationTopicType.Branch) {
      request.branchId = this.entity.branch.id;
      request.deskId = null;
    }
    if (this.entity.type === ConversationTopicType.Desk) {
      request.branchId = this.entity.branch.id;
      request.deskId = this.entity.desk.id;
    }
    request.name = this.entity.name;
    request.isPublic = this.entity.isPublic;
    request.isEnabled = this.entity.isEnabled;
    request.offlineMessage = this.entity.offlineMessage;

    await AgencySettingsModule.createConversationTopic(request);
    this.dialog = false;
  }
}
